import { useEffect, useState } from 'react';
import DrawflowReactor from '../Plugin/DrawflowReactor.jsx';
import Button from '../ui/Button.jsx';
import { Card, CardBody, CardFooter } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const Matching = ({ ...props }) => {
    const { heading, groups, button, info, fn } = props;
    const [joinMatching, setJoinMatching] = useState([]);

    const handleJoin = (term, condition) => {
        setJoinMatching((prevJoinMatching) => [...prevJoinMatching, { term: term, condition: condition }]);
    };
    const handleRemove = (term, condition) => {
        setJoinMatching((prevJoinMatching) => prevJoinMatching.filter((item) => !(item.term === term && item.condition === condition)));
    };

    useEffect(() => {
        fn.handleAction('set:form', joinMatching);
    }, [joinMatching]);

    return (
        <div className="component-grouping">
            <HeadingOne heading={heading} />
            <Card>
                <CardBody>
                    <DrawflowReactor term={groups[0]} condition={groups[1]} fn={{ ...fn, handleJoin, handleRemove }} />

                    {info && (
                        <div className="mt-8 flex items-center gap-4 text-base">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <path
                                    fill="currentColor"
                                    d="M11 17h2v-6h-2zm1-8q.425 0 .713-.288T13 8t-.288-.712T12 7t-.712.288T11 8t.288.713T12 9m0 13q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"
                                />
                            </svg>
                            {info}
                        </div>
                    )}
                </CardBody>
                <CardFooter>{button && <Button {...button} onClick={() => fn.handleAction(button.action)} />}</CardFooter>
            </Card>
        </div>
    );
};

export default Matching;
